module.exports = __webpack_public_path__ + "static/media/value_prop_img_1.60e9222c.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-SPRINT/value_prop_img_1.jpg
// module id = 2664
// module chunks = 0